"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
const Hide = ({
  on = [],
  block,
  children
}) => /*#__PURE__*/_react.default.createElement("div", {
  className: (0, _clsx.default)(block ? "block" : "inline-block", {
    "max-mm:hidden": on.includes("smallMobile"),
    "mm:max-lm:hidden": on.includes("mediumMobile"),
    "lm:max-tb:hidden": on.includes("largeMobile"),
    "tb:max-de:hidden": on.includes("tablet"),
    "de:max-ld:hidden": on.includes("desktop"),
    "ld:hidden": on.includes("largeDesktop")
  })
}, children);
var _default = Hide;
exports.default = _default;